/**
 * Local storage contract. The app only talks to this interface; the implementation is
 * IndexedDB (Dexie) on the web and SQLite on iOS/Android, chosen at startup.
 */
export const COLLECTIONS = ["notes", "lists", "listItems", "bookmarks"] as const;
export type Collection = (typeof COLLECTIONS)[number];

export interface LocalStore {
  all<T>(collection: Collection): Promise<T[]>;
  putMany<T extends { id: string }>(collection: Collection, records: T[]): Promise<void>;
  getMeta<T>(key: string): Promise<T | undefined>;
  setMeta(key: string, value: unknown): Promise<void>;
  /** Remove every user record and meta value (used by "Erase data on this device"). */
  clear(): Promise<void>;
}
